import Vue from 'vue'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import 'element-ui/lib/theme-chalk/display.css'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router/account/admin.js'
import store from './store'
import '@/style/_style.scss'
import i18n from './i18n'
Vue.use(ElementUI,{locale});
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.directive('clickoutside', {
  bind: function(el, binding, vnode){
      function documentHandler(e){
          if(el.contains(e.target)){
              return false
          }
          if(binding.expression){
              binding.value(e)
          }
      }
      el._vueClickOutside_ = documentHandler;
      document.addEventListener('click',documentHandler);
  },
  unbind: function(el, binding){
      document.removeEventListener('click',el._vueClickOutside_);
      delete el._vueClickOutside_;
  }
})
let vue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
window.vue = vue;
function checkMobile(){
    const mobileKeyword = ['Android','webOS','iPhone','iPad','iPod','BlackBerry','Windows Phone'];
    return mobileKeyword.some(device => navigator.userAgent.match(device))
}
if(checkMobile()){
    let vh = window.innerHeight;
    vh = vh - 50;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
} else{
    document.documentElement.style.setProperty('--vh', '100vh');
}



